import React, { useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { IReduxState } from "../../../../store";
import { ADMIN_SERVER_BASE_URL, apiClient } from "../../../../util/apiClient";
import { addDroits, editDroit, setDescriptionEdit, setObjDroit, setOpenDialogDroit, setValueEdit } from "./droitSlice";
import FormulaireDroit from "./Formulaire";
import EditFormulaireDroit from "./EditFormulaireDroit";
import MyDialogComponent from '../../../../components/Common/MyDialogComponent';
import CommonAlert from '../../../../components/Common/CommonAlert';




const AddDroit = () => {

    //redux
    const dispatch = useDispatch()
    const { openDialogDroit, objDroit, valueEdit, descriptionEdit } = useSelector((state: IReduxState) => state.droits);
    const { objSousModuleDroit } = useSelector((state: IReduxState) => state.sousModuleDroit);


    //hooks
    const [valueF, setValueF] = useState("");
    const [description, setDescription] = useState("");
    const [openAlert, setOpenAlert] = useState(false);


    const handleSave = async () => {
        try {
            const apiPayload = {
                idSousModuleDroit: objSousModuleDroit.idSousModuleDroit,
                libDroit: valueF,
                descriptionDroit: description
            }
            const res: any = await apiClient.post(ADMIN_SERVER_BASE_URL, "/tablesystem/creerdroit", apiPayload)
            if (res.status === 1) {
                const newD = { ...res.data, id: res.data.idDroit, libelle: res.data.libDroit }
                dispatch(addDroits(newD))
                // dispatch(setFilterDroits(false));
                setValueF("")
                setDescription("")
            } else {
                console.log("status !==1")
            }

        } catch (error) {
            console.log("🚀 ~ file: AddDroit.tsx ~ line 51 ~ handleSave ~ error", error)

        }
    }


    const editItem = async () => {
        try {
            const apiPayload = { idDroit: objDroit.idDroit, libDroit: valueEdit, descriptionDroit: descriptionEdit }
            const res: any = await apiClient.post(ADMIN_SERVER_BASE_URL, "/tablesystem/modifierdroit", apiPayload)
            if (res.status === 1) {
                const newD = { ...res.data, idSousModuleDroit: objDroit.idSousModuleDroit, id: res.data.idDroit, libelle: res.data.libDroit }
                dispatch(editDroit(newD))
                dispatch(setOpenDialogDroit(false));
                setValueF("")
                setDescription("")
            } else {
                console.log("status !==1")
            }
        } catch (error) {
            console.log("🚀 ~ file: AddDroit.tsx:70 ~ editItem ~ error:", error)
        }
    };

    const handleOpen = () => {
        //verifier si un sous module a été selectionné avant d'ouvir le dialog d'enreegistrement du droit
        if (Object.keys(objSousModuleDroit).length > 0) {
            dispatch(setOpenDialogDroit(true));
            dispatch(setObjDroit({}));
            setValueF("")
            setDescription("")
        } else {
            setOpenAlert(true)
        }
    };

    const handleClose = () => {
        dispatch(setOpenDialogDroit(false));
    };

    const handleAlertClose = () => {
        setOpenAlert(false)
    }

    return (
        <div>
            <MyDialogComponent
                // dialogTitle={`${Object.keys(objDroit).length > 0 ? "Modifier" + " " + objDroit.libelleDroit : "Créer une fonctionnalite"}`}

                dialogTitle={`${Object.keys(objDroit).length > 0
                    ? `Modifier ${objDroit.libDroit}`
                    : `Créer une fonctionnalite`
                    }`}

                dialogContent={
                    Object.keys(objDroit).length > 0
                        ? <EditFormulaireDroit
                            setValueEdit={setValueEdit}
                            valueEdit={valueEdit}
                            descriptionEdit={descriptionEdit}
                            setDescriptionEdit={setDescriptionEdit}
                        />
                        : <FormulaireDroit
                            setValueF={setValueF}
                            valueF={valueF}
                            description={description}
                            setDescription={setDescription}
                        />}
                handleSave={
                    Object.keys(objDroit).length > 0
                        ? editItem
                        : handleSave
                }
                openDialog={openDialogDroit}
                handleOpen={handleOpen}
                handleClose={handleClose}
            />
            <CommonAlert
                severity="warning"
                variant="filled"
                description="Veuillez selectionner un droit."
                title="Alerte !"
                openAlert={openAlert}
                handleAlertClose={handleAlertClose}
            />
        </div>
    );
}

export default AddDroit;
